import predicates from '../predicates'
import selectors from '../selectors'
import { ORGANIC_TRAFFIC_SOURCE, SEARCH_PLATFORMS } from '../constants'

const organic = {
  rule: predicates.referrerIncludesPlatform(
    SEARCH_PLATFORMS.GOOGLE,
    SEARCH_PLATFORMS.BING,
    SEARCH_PLATFORMS.YAHOO
  ),
  extractor: traffic => {
    const trafficSource = ORGANIC_TRAFFIC_SOURCE
    const trafficId = selectors.referrerHostname(traffic)

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default organic



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/organic.js